import * as Yup from 'yup';
import { PqrResponseMedium } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrResponseMedium = {
    responseMedium: '',
    observation: '',
};

export const validationSchema = Yup.object({});
